<template>
  <Layout>
    <PageHeader :title="title" :backButton="true" :prevRoutePath="backUrl" />
    <div class="row">
      <div class="col-lg-12 col-sm-12 mb-3">
        <div class="card p-4">
          <div class="media">
            <div class="avatar-sm mr-3">
              <span
                class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22"
              >
                <i class="bx bx-user-plus bx-md"></i>
              </span>
            </div>
            <div class="media-body">
              <h5 class="mt-3">{{ $t("tiktok.add-new") }}</h5>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-sm-8">
              <h5 v-if="result && !loading">
                {{ $t("tiktok.total-results") }}: {{ totalResult }}
              </h5>
            </div>
            <div class="col-sm-4 text-right">
              <div class="input-group">
                <input
                  id="search"
                  type="text"
                  class="form-control"
                  v-model="searchKey"
                  :placeholder="$t('all.searchh')"
                  aria-describedby="search"
                  @keyup.enter="searchTiktok"
                />
                <div class="input-group-prepend">
                  <button
                    id="search"
                    class="input-group-text bg-primary text-white"
                    @click="searchTiktok"
                  >
                    <i class="bx bx-search-alt search-icon"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4 mb-4">
            <div
              class="col-sm-12 p-5 m-5 text-center"
              v-if="!search && searchResult == 0 && error == ''"
            >
              ..
            </div>
            <div class="col-sm-12 p-5 m-5" v-if="loading">
              <div class="text-center loading">
                <b-spinner label="Loading..."></b-spinner><br />
                Loading..
              </div>
            </div>
            <div
              v-if="error !== '' && !loading"
              class="row mt-5 mb-5 p-5 mx-auto"
            >
              <div class="text-center">
                <span class="text-danger">{{ error }}</span>
              </div>
            </div>
            <div class="col-sm-12" v-if="!loading && dnf && !searchResult[0]">
              <div class="text-center loading">
                {{ $t("all.dnf") }}
              </div>
            </div>
            <div class="col-sm-12" v-if="!search || searchResult !== 0">
              <div class="row" v-if="searchResult[0]">
                <div
                  class="col-sm-4 col-md-4 mb-3"
                  v-for="(result, index) in searchResult"
                  :key="index"
                >
                  <div class="card p-3 h-100 border">
                    <div class="row text-Secondary">
                      <div class="col-sm-8">
                        <div class="media mb-3">
                          <div class="avatar-md mr-2">
                            <img
                              :src="
                                'https://m-p16.akamaized.net/obj/' +
                                result.avatar_uri
                              "
                              class="mr-3 rounded-circle avatar-md"
                              alt="user-pic"
                            />
                          </div>
                          <div class="media-body">
                            <h6 class="mt-3">
                              {{ result.search_user_desc }}
                              <span v-if="result.is_star == true"
                                ><i
                                  class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"
                                ></i
                              ></span>
                            </h6>
                            <p class="text-secondary">
                              (<span class="mb-1">@{{ result.unique_id }}</span
                              >) &nbsp;
                              <span
                                v-if="result.is_private_account == 1"
                                class="text-secondary"
                              >
                                <i
                                  class="text-dark mdi mdi-shield-lock-outline mdi-24px"
                                ></i>
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4 text-right">
                        <router-link to="#">
                          <b-button
                            class="btn btn-sm"
                            variant="primary"
                            @click="searchUserinfo(result)"
                          >
                            <div
                              v-show="
                                loading_add &&
                                result.unique_id == loading_unique
                              "
                              class="spinner-border spinner-border-sm"
                              role="status"
                            ></div>
                            {{ $t("twitter.twitter-search.add") }}
                          </b-button>
                        </router-link>
                      </div>
                      <div class="col-sm-6 mb-2">
                        <h6>{{ $t("tiktok.upload") }} :</h6>
                      </div>
                      <div class="col-sm-6 mb-2 text-right">
                        <span class="text-secondary">{{
                          result.aweme_count
                        }}</span>
                      </div>
                      <div class="col-sm-6 mb-2">
                        <h6>{{ $t("tiktok.followers") }} :</h6>
                      </div>
                      <div class="col-sm-6 mb-2 text-right">
                        <span class="text-secondary">{{
                          result.follower_count
                        }}</span>
                      </div>
                      <div class="col-sm-6 mb-2">
                        <h6>{{ $t("tiktok.following") }} :</h6>
                      </div>
                      <div class="col-sm-6 text-right">
                        <span class="text-secondary">{{
                          result.following_count
                        }}</span>
                      </div>
                      <div class="col-sm-6 mb-2">
                        <h6>{{ $t("tiktok.likes") }} : {{ result.likes }}</h6>
                      </div>
                      <div class="col-sm-6 mb-2 text-right">
                        <span class="text-secondary">{{
                          result.total_favorited
                        }}</span>
                      </div>
                      <div class="col-sm-12 text-center">
                        <hr />
                        <a
                          :href="'https://www.tiktok.com/@' + result.unique_id"
                          target="_blank"
                          rel="noopener noreferrer"
                          ><b>{{ $t("tiktok.see-profile") }}</b></a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import InstaService from "@/helpers/osintgram.service.js";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
import SocmedService from "@/helpers/socmed.service";
import Swal from "sweetalert2";
import PreferenceService from "@/helpers/preference.service.js";

export default {
  page: {
    title: "Tools Tiktok",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      avatar: process.env.VUE_APP_BASE_API_URL_OSINT + "stream-profil/?name=",
      pref_userinfo: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_userinfo2: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_search: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_search2: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_avatar: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      backUrl: "/tiktok",
      loading: false,
      search: true,
      result: false,
      totalResult: "",
      error: "",
      dnf: false,
      searchKey: "",
      loading_unique: "",
      loading_add: false,
      loadingInfo: false,
      searchResult: [],
      searchResultOsint: [],
      tableData: [],
      selected: [],
      selectAll: false,
      search: false,
      title: "Tiktok",
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  methods: {
    getPreferencesSearch() {
      let id = 70;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref = response.data.data;
          this.pref_search.api_host = response.data.data.api_host;
          this.pref_search.x_rapidapi_host = response.data.data.api_header_host;
          this.pref_search.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getPreferencesSearch2() {
      let id = 71;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref_search = response.data.data;
          this.pref_search2.api_host = response.data.data.api_host;
          this.pref_search2.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_search2.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getPreferencesUserInfo() {
      let id = 80;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref_userinfo = response.data.data;
          this.pref_userinfo.api_host = response.data.data.api_host;
          this.pref_userinfo.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_userinfo.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // getPreferencesUserInfo2() {
    //   let id = 14;
    //   PreferenceService.getRapidApiByID(id)
    //     .then((response) => {
    //       // console.log(response.data.data);
    //       // this.pref_userinfo = response.data.data;
    //       this.pref_userinfo2.api_host = response.data.data.api_host;
    //       this.pref_userinfo2.x_rapidapi_host =
    //         response.data.data.api_header_host;
    //       this.pref_userinfo2.x_rapidapi_key =
    //         response.data.data.api_header_key;
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },

    searchTiktok() {
      this.error = "";
      this.result = false;
      this.dnf = false;
      // let searchData = this.removeSpace(this.searchKey);
      if (this.searchKey != "") {
        this.search = true;
        this.loading = true;
        this.searchResult = [];
        let headers = {
          "content-type": "application/json",
          "x-rapidapi-host": this.pref_search.x_rapidapi_host,
          "x-rapidapi-key": this.pref_search.x_rapidapi_key,
        };

        return axios
          .get(
            this.pref_search.api_host +
              "?keyword=" +
              this.searchKey +
              "&count=21&cursor=0",
            {
              headers: headers,
            }
          )
          .then((response) => {
            let data_search = response.data.user_list;
            // console.log("data", data_search);
            data_search.forEach((elm, idx) => {
              const val = elm.user_info;
              let data = {
                avatar_uri: val.avatar_uri,
                aweme_count: val.aweme_count,
                follower_count: val.follower_count,
                follower_status: val.follow_status,
                following_count: val.following_count,
                is_private_account: val.is_private_account,
                is_star: val.is_star,
                live_agreement: val.live_agreement,
                live_verify: val.live_verify,
                nickname: val.nickname,
                search_user_desc: val.search_user_desc,
                search_user_name: val.search_user_name,
                sec_uid: val.sec_uid,
                total_favorited: val.total_favorited,
                uid: val.uid,
                unique_id: val.unique_id,
                verification_type: val.verification_type,
                verify_info: val.verify_info,
              };
              this.searchResult.push(data);
            });
            // let total = response.data.pagination['total'];
            this.totalResult = this.searchResult.length;
            this.loading = false;
            this.result = true;
          })
          .catch((err) => {
            console.log(err);
            this.searchTiktok2();
          });
      }
    },

    searchTiktok2() {
      this.error = "";
      this.result = false;
      this.dnf = false;
      let searchData = this.removeSpace(this.searchKey);
      if (this.searchKey != "") {
        this.search = true;
        this.loading = true;
        this.searchResult = [];
        let headers = {
          "content-type": "application/json",
          "x-rapidapi-host": this.pref_search2.x_rapidapi_host,
          "x-rapidapi-key": this.pref_search2.x_rapidapi_key,
        };
        // console.log(headers);
        return axios
          .get(
            this.pref_search2.api_host +
              "?keyword=" +
              this.searchKey +
              "&count=21&cursor=0",
            {
              headers: headers,
            }
          )
          .then((response) => {
            // let data_search = response.data.user_list;
            let data_search = [];
            // console.log("data", data_search);
            data_search.forEach((elm, idx) => {
              const val = elm.user_info;
              let data = {
                avatar_uri: val.avatar_uri,
                aweme_count: val.aweme_count,
                follower_count: val.follower_count,
                follower_status: val.follow_status,
                following_count: val.following_count,
                is_private_account: val.is_private_account,
                is_star: val.is_star,
                live_agreement: val.live_agreement,
                live_verify: val.live_verify,
                nickname: val.nickname,
                search_user_desc: val.search_user_desc,
                search_user_name: val.search_user_name,
                sec_uid: val.sec_uid,
                total_favorited: val.total_favorited,
                uid: val.uid,
                unique_id: val.unique_id,
                verification_type: val.verification_type,
                verify_info: val.verify_info,
              };
              this.searchResult.push(data);
            });

            this.totalResult = this.searchResult.length;
            this.loading = false;
            this.result = true;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    searchUserinfo(result) {
      this.loading_unique = result.unique_id;
      var iduser = result.unique_id;
      var ava_tt = result.avatar_uri;
      this.error = "";
      if (this.searchKey != "") {
        this.search = true;
        this.loading_add = true;
        let headers = {
          "content-type": "application/json",
          "x-rapidapi-host": this.pref_userinfo.x_rapidapi_host,
          "x-rapidapi-key": this.pref_userinfo.x_rapidapi_key,
        };
        // console.log(headers);
        return axios
          .get(this.pref_userinfo.api_host + "?username=" + iduser, {
            headers: headers,
          })
          .then((response) => {
            let val = response.data?.user;
            // console.log("data userinfo", val);
            let data = {
              video_count: val?.visible_videos_count,
              followers: val?.follower_count,
              following: val?.following_count,
              likes: val?.total_favorited,
              user_id: val?.uid,
              sec_id: val?.sec_uid,
              is_verified: val?.verification_type == true ? "1" : "0",
              is_private: val?.secret == true ? "1" : "0",
              keterangan: "",
              account: val?.unique_id,
              full_name: val?.nickname,
              bio: val?.signature,
              picture: val?.avatar_thumb,
              avatar: ava_tt,
            };
            this.saveTiktok(data);
            console.log("data save", data);
            this.loading = false;
            this.loading_add = false;
            this.result = true;
          })
          .catch((err) => {
            console.log(err);
            this.loading_add = false;
          });
      }
    },

    saveTiktok(data) {
      // console.log(data);
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      var data_tt = {
        video_count: data.video_count,
        followers: data.followers,
        following: data.following,
        likes: data.likes,
        user_id: data.user_id,
        sec_id: data.sec_id,
        is_verified: data.is_verified,
        is_private: data.is_private,
        keterangan: data.keterangan,
        account: data.account,
        full_name: data.full_name,
        bio: data.bio,
        picture: data.avatar,
        pin: 0,
      };
      console.log(data_tt);
      SocmedService.createTiktok(data_tt)
        .then((response) => {
          if (response.status == 212) {
            Swal.fire("Tiktok is Updated", "", "success");
          } else {
            Swal.fire(this.$t("alert.alert-save"), "", "success");
          }
          this.loading_add = false;
          (this.searchResult = ""),
            (this.searchKey = ""),
            this.$router.push("/tiktok");
          this.search = false;
          this.dnf = false;
          this.searchResult = 0;
          this.result = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading_add = false;
        });
    },

    formatDate(value) {
      return moment(value).format("dddd, YYYY-MM-DD hh:mm");
    },

    removeSpace(value) {
      let str = value.replace(/\s/g, "");
      return str;
    },
  },
  mounted() {
    this.getPreferencesSearch();
    this.getPreferencesSearch2();
    this.getPreferencesUserInfo();
    // this.getPreferencesUserInfo2();
  },
};
</script>

<style scoped>
.card {
  border: 0px solid #f1f1f1;
}
</style>
